import { Grid, Typography } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey, GlobalClassKeys } from "assets/jss/common-styles";
import MuiMessageBlock from "components/MuiExtras/MuiMessageBlock";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import MuiQuote from "components/MuiExtras/Typography/MuiQuote";
import ApprovalStatusName from "components/Translations/ApprovalStatusName";
import UserProfileAvatar from "components/UserProfileAvatar";
import { Formaters } from "lib/Formarters";
import { ApprovalStatus, PublicationActionStatus, PublicationActionType } from "models/ApiEnums";
import { FeedItemActionRequesterDto, FeedItemDto, UserShortView } from "models/ApiModels";
import * as React from "react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IRequestRenderProps {
    user: UserShortView;
    quote: string;
    headerline: string;
    subtitle?: string;
    footer?: string | JSX.Element;
}

/////////////////////////////////////////////////////////////////////////////////////

export const ActionMessageRender: React.FC<IRequestRenderProps & StyledComponentProps<FeedClassKey>> = (props) => {
    const { user, quote, classes, footer, headerline, subtitle } = props;

    return (
        <div className={classes.requesterContainer}>
            <Grid container>
                <Grid item className={GlobalClassKeys.grow}>
                    <div className={classes.requesterBody}>
                        <Typography variant="caption">
                            <MuiMuted>
                                {headerline}
                            </MuiMuted>
                        </Typography>
                        <Typography variant="subtitle2">
                            <b>{subtitle}</b>
                        </Typography>

                        {
                            quote &&
                            <MuiQuote content={quote} />
                        }
                    </div>
                    {footer}
                </Grid>
                <Grid item>
                    <UserProfileAvatar user={user} />
                </Grid>
            </Grid>
        </div >
    );
};

/////////////////////////////////////////////////////////////////////////////////////

interface IOtherRequesterProps {
    data: FeedItemActionRequesterDto;
}

export const ActionOtherRequesterBody: React.FC<IOtherRequesterProps & StyledComponentProps<FeedClassKey>> = (props) => {
    const { data, classes } = props;
    const message = `${data.requester.name} denunciou em ${Formaters.relativeTime(data.requestedOn)}.`;

    return <ActionMessageRender user={data.requester} quote={data.requesterComment} headerline={message} classes={classes} />;
};

/////////////////////////////////////////////////////////////////////////////////////


interface IProps {
    data: FeedItemDto;
}

export const ActionRequesterBody: React.FC<IProps & StyledComponentProps<FeedClassKey>> = (props) => {

    const { t } = useTranslation();
    const { data: { action }, classes } = props;
    const message = t(`Common.Feed.ActionRequester.PublicationActionType.${PublicationActionType[action.actionType]}`, { name: action.requester.name, requestedOn: action.requestedOn });;

    return <ActionMessageRender user={action.requester} quote={action.requesterComment} headerline={message} subtitle={action.actionTitle} classes={classes} />;
};

/////////////////////////////////////////////////////////////////////////////////////

export const ActionOwnBody: React.FC<IProps & StyledComponentProps<FeedClassKey>> = (props) => {
    const { t } = useTranslation();
    const { data: { action }, classes } = props;
    const message = t(`Common.Feed.ActionOwn.PublicationActionType.${PublicationActionType[action.actionType]}`, { name: action.requester.name, requestedOn: action.requestedOn });;

    var footer: string | JSX.Element;
    if (action.actionStatus == PublicationActionStatus.Ignored)
        footer = <MuiMessageBlock variant="warning" message="Ignorado" />;
    else if (action.actionStatus == PublicationActionStatus.Pending)
        footer = <MuiMessageBlock variant="mutedDark" message="Em análise" />;
    else if (action.actionStatus == PublicationActionStatus.Processed && action.ownerResultStatus) {

        var notes = (action.ownerNotes && action.ownerNotes.length > 0)
            ? (<i>{action.ownerNotes}</i>)
            : null;

        footer = (
            <Fragment>
                <MuiMessageBlock
                    variant={action.ownerResultStatus == ApprovalStatus.Approved ? "success" : "error"}
                    message={<ApprovalStatusName approvalStatus={action.ownerResultStatus} />}
                />
                {notes}
            </Fragment>);
    }

    return (
        <ActionMessageRender
            user={action.owner}
            quote={action.requesterComment}
            headerline={message}
            subtitle={action.actionTitle}
            footer={footer}
            classes={classes}
        />
    );
};

/////////////////////////////////////////////////////////////////////////////////////

export const ActionSuggestionBody: React.FC<IProps & StyledComponentProps<FeedClassKey>> = (props) => {
    const { t } = useTranslation();
    const { data: { action }, classes } = props;
    const message = t("Common.Feed.Literals.ActionSuggestionText", { name: action.requester.name, requestedOn: action.requestedOn });;

    return <ActionMessageRender user={action.requester} quote={action.requesterComment} headerline={message} subtitle={action.actionTitle} classes={classes} />;
};

/////////////////////////////////////////////////////////////////////////////////////